import React, { Component } from 'react'
import YVTextField from 'aria-viewer/tour/components/fields/yvTextfield'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import RegistrationCarousel from './registrationCarousel'

class RegistrationPage1 extends Component {
    constructor(props) {
        super(props)

        this.handleFocus = this.handleFocus.bind(this)
    }
    addFields() {
        const { textField } = styleguide.inputfields
        const { fields, handleChange } = this.props
        let hasScrolledError = false

        // this is to filter out what ever fields that does not belong to page1
        // and set it to null
        let filteredFields = {}
        for (var key in fields) {
            if (fields[key].hasOwnProperty('id')) {
                filteredFields[fields[key].id] = fields[key]
            }
        }

        return Object.keys(filteredFields).map((key, index) => {
            const focus = !hasScrolledError && filteredFields[key].error
            hasScrolledError = hasScrolledError || filteredFields[key].error

            const item = {
                ...filteredFields[key],
                focus,
            }

            return (
                <YVTextField
                    key={index}
                    onChange={handleChange}
                    onFocus={this.handleFocus}
                    item={item}
                    {...textField}
                    style={Object.assign({}, textField.style, item.style)}
                />
            )
        })
    }

    handleFocus(item, event, ref) {
        const { handleFocusField } = this.props
        handleFocusField && handleFocusField(ref.input)
    }

    componentWillUnmount() {
        clearTimeout(this.focusTimeout)
    }

    componentDidMount() {
        const { onLoad } = this.props

        onLoad && onLoad()
    }

    render() {
        const { formInfo, width, height } = this.props

        return (
            <div>
                <RegistrationCarousel {...{ formInfo, width, height }} />
                <div style={{ margin: '-5px 0 10px' }}>{this.addFields()}</div>
            </div>
        )
    }
}
export default RegistrationPage1
